<template>
  <div v-if="is_from_mobile == 1">
    <button class="navbar-toggler !rounded-r-full overflow-hidden relative -left-3" type="button"
      data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar"
      aria-label="Toggle navigation">
      <div class="flex items-center gap-2 py-2 px-3 !bg-[#A084E8]">
        <img src="../assets/images/plan-nav-icon.png" alt="Plan Icon" class="w-5 h-5 object-contain">
        <span class="text-[16px] text-[#fff]">Plans</span>
      </div>
    </button>
    <div class="offcanvas offcanvas-start  h-max !w-full" tabindex="-1" id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel" data-bs-scroll="false" data-bs-backdrop="true">
      <button type="button" class="absolute top-0 right-0 w-7 h-10 !rounded-l-full !bg-red-400 translate-y-14"
        data-bs-dismiss="offcanvas" aria-label="Close">
        <i class="fa fa-angle-left !text-[20px] text-[#fff]" aria-hidden="true"></i>
      </button>
      <div class="offcanvas-body rounded-[10px] m-3 w-[85%]">
        <mobileSidebarNavigation />
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="grid laptop:grid-cols-2 desktop:grid-cols-3 largeDesktop:pt-0 laptop:pt-5 largeDesktop:grid-cols-3 mobile:grid-cols-1 items-center gap-5">
      <div class="mobile:hidden tablet:hidden laptop:hidden desktop:block largeDesktop:block">
        <ol v-if="isBreadcrumbShow"
          class="flex items-center justify-center p-2 rounded-full w-max mx-auto m-0 bg-opacity-80 bg-white">
          <li class="px-2">
            <router-link to="/protection-plan/nrg/bundle-list" class="no-underline text-[#8479E1]">
              Dashboard
            </router-link>
          </li>
          <li class="border-l border-[#666666] text-[#666666] px-2">{{ getPageName() }}</li>
        </ol>
      </div>
      <div class="w-3/4 laptop:w-full largeDesktop:w-3/4 mx-auto mobile:hidden laptop:block largeDesktop:block">
        <globalSearch
          :inputClass="'rounded-full shadow-md pl-3 !pr-20 laptop:py-2 largeDesktop:py-2.5 w-full laptop:h-12 largeDesktop:h-14 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none '"
          :buttonclass="'absolute top-2 right-2 laptop:w-8 laptop:h-8 largeDesktop:w-10 largeDesktop:h-10'"
          :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[3.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
          :clearable="true" v-model="search" :onEnter="handleSearch" :onClear="handleClear" :readonly="loading" />
      </div>
      <div class="relative flex items-center justify-end h-10">
        <a v-if="$route.name == 'globalSearch'" @click="backButton()"
          class="absolute top-0 left-0 cursor-pointer w-10 h-10 p-2 rounded-full flex items-center justify-center laptop:!hidden bg-gradient-to-r from-[#16BCFF] to-[#168EFF]">
          <img src="../assets/images/back-arrow-icon.png" alt="Back Arrow Button" class="w-full h-full">
        </a>
        <div class="flex mobile:justify-center tablet:justify-center laptop:justify-end largeDesktop:justify-end gap-3">
          <!-- <createQuote :button-warpper-class="'relative inline-block text-left'"
        :buttonClass="'flex items-center mobile:gap-2 largeDesktop:gap-3 mobile:px-2 largeDesktop:px-3 py-2 shadow-lg text-gray-900 rounded-full relative group hover:!bg-teal-500 transition-all bg-white '"
        :buttonTextClass="'font-roboto text-base text-gray-900 group-hover:!text-white'"
        :buttonIconClass="'relative mobile:w-4 mobile:h-4 laptop:w-7 laptop:h-7 largeDesktop:w-7 largeDesktop:h-7 object-contain'"
        :dropdownListClass="'origin-top-right absolute mobile:-right-[77px] tablet:right-0 mt-2 w-52 rounded-md shadow-lg z-10 bg-white'"
        :dropdownListLIClass="'rounded-md overflow-hidden hover:bg-gray-200'"
        :dropdownListAnchorClass="'font-roboto block px-2 py-2 text-sm no-underline cursor-pointer text-gray-700 hover:bg-gray-200'" /> -->
          <!-- <button @click="contractorModal()" class="px-3 py-0.5 rounded-full shadow-lg bg-opacity-70 bg-white">
        <img src="../assets/images/perfectMatch-logo.png" alt="company Logo" class="w-40 h-10 object-contain ">
      </button> -->

          <button class="!cursor-auto"
            :class="isSquare ? 'overflow-hidden p-1 shadow-lg bg-opacity-50 bg-white rounded-full' : 'px-3 overflow-hidden p-1 shadow-lg bg-opacity-50 bg-white rounded-full '">
            <img v-if="userObject.user" :src="userObject?.user?.company_logo ?? ''" alt="Company Logo" ref="logoImage"
              :class="isSquare ? 'mobile:w-8 mobile:h-8 desktop:w-14 desktop:h-14 object-contain rounded-full' : 'mobile:w-32 mobile:h-6 largeDesktop:w-40 largeDesktop:h-8 object-contain '"
              @load="checkImageShape" />
          </button>

          <!-- <button class="px-3 tablet:py-0.5 mobile:py-1 rounded-full shadow-lg bg-opacity-50 bg-white">
          <img v-if="userObject.user" :src="userObject?.user?.company_logo ?? ''" alt="Company Logo"
            class="mobile:w-32 mobile:h-6 largeDesktop:w-40 largeDesktop:h-10 object-contain ">
        </button> -->
        </div>
      </div>
    </div>
  </div>
  <!-- Contractor Modal Modal -->
  <div class="modal fade" id="contractorModal" ref="contractorModal" tabindex="-1" aria-labelledby="contractorModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered tablet:w-[500px] !absolute !right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative h-[100px]">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <img src="../assets/images/profile-bg.png" class="w-full object-contain absolute left-0 top-0"
                alt="backgroundImage">
              <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12">
                <h6 class="m-0 text-xl font-roboto font-semibold text-black-100">
                  Details
                </h6>
                <img src="../assets/images/nrg-logo.png" alt="contractor Logo" class="w-14 h-14 object-contain">
              </div>
            </div>
          </div>
          <div class="max-h-[90vh] overflow-y-auto customScrollbar mt-4">
            <companyDetailDropdown />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import globalSearch from './partialComponent/customInput.vue';
import companyDetailDropdown from "./companyDetailModal.vue"
import {
  mapGetters, mapActions
} from "vuex";
import router from "../router";
import mobileSidebarNavigation from "./mobileSidebarNavigation.vue";
export default {
  components: {
    globalSearch,
    // createQuote,
    companyDetailDropdown,
    mobileSidebarNavigation
  },
  data() {
    return {
      search: '',
      loading: false,
      isSquare: null,
      is_from_mobile: localStorage.getItem("is_from_mobile", 0) ?? 0
    }
  },
  computed: {
    ...mapGetters(["userObject"]),
    isBreadcrumbShow() {
      if (this.$route.name == "globalSearch") {
        return false
      }
      else {
        return true
      }
    },
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if (newQuery) {
          this.search = this.$route.query.q
        }
      },
    },
  },

  mounted() {
    const observer = new MutationObserver(() => {
      const offcanvas = document.getElementById('offcanvasNavbar');
      if (offcanvas.classList.contains('show')) {
        document.documentElement.style.overflow = 'hidden'; // <html>
      } else {
        document.documentElement.style.overflow = '';
      }
    });

    const targetNode = document.getElementById('offcanvasNavbar');
    if (targetNode) {
      observer.observe(targetNode, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  },

  methods: {
    ...mapActions(["getProfile"]),

    checkImageShape() {
      const img = this.$refs.logoImage;
      if (img && img.naturalWidth && img.naturalHeight) {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        const ratio = width / height;
        console.log("checkImageShape", width, height, ratio);

        // Consider it square if width and height differ by no more than ±10%
        this.isSquare = ratio >= 0.9 && ratio <= 2;
      }
    },

    backButton() {
      this.$router.go(-1);
    },
    contractorModal() {
      this.modal = new Modal(this.$refs.contractorModal);
      this.modal.show();
    },
    getPageName() {
      if (this.$route.name == 'salesHistory') {
        return 'Sales History'
      } else if (this.$route.name == 'commisionAmount') {
        return 'Commissions'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Protection Plans'
      } else {
        return ''
      }

    },
    setLoading() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 200);
    },
    handleClear() {
      this.search = ''
      this.handleSearch()
    },
    handleSearch() {
      let search = ""
      search = this.$helper.isEmpty(this.search) ? '' : this.search.trim()
      this.setLoading()
      if (this.$route.name == 'globalSearch') {
        this.$router.replace({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      } else {
        this.$router.push({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      }
    }

  },
};
</script>